import { render, staticRenderFns } from "./SlashIcon.vue?vue&type=template&id=5b7254cc&"
import script from "./SlashIcon.vue?vue&type=script&lang=js&"
export * from "./SlashIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports